import api from 'api';

export const PRODUCTS_ASYNC_UPDATE_SUCCESS = 'PRODUCTS_ASYNC_UPDATE_SUCCESS';
export const PRODUCTS_RESET_STATE = 'MENU_ITEM_COST_RECIPES_RESET_STATE';
export const DEBOUNCE_PRODUCTS = 'DEBOUNCE_PRODUCTS';
export const SET_LOADING_PRODUCTS_STATUS = 'SET_LOADING_PRODUCTS_STATUS';
export const UPDATE_PRODUCT_PRICE = 'UPDATE_PRODUCT_PRICE';
export const LOAD_PRODUCT_PRICE_ERROR = 'LOAD_PRODUCT_PRICE_ERROR';
export const SET_PRODUCTS_RESET_KEY_STATUS = 'SET_PRODUCTS_RESET_KEY_STATUS';

export const SAME_PROCESS_FLAG = '1';


function productsAsyncUpdateSuccess(data) {
  return {
    type: PRODUCTS_ASYNC_UPDATE_SUCCESS,
    data,
  };
}

function updateProductPrice(data) {
  return {
    type: UPDATE_PRODUCT_PRICE,
    data,
  };
}

export function resetProductsState() {
  return {
    type: PRODUCTS_RESET_STATE,
  };
}

export function setLoadingProductsStatus(isLoading) {
  return {
    type: SET_LOADING_PRODUCTS_STATUS,
    isLoading,
  };
}

function setProductsResetKeyStatus(resetKey) {
  return {
    type: SET_PRODUCTS_RESET_KEY_STATUS,
    resetKey,
  };
}

export function getProducts(opcoId, syscoCustomerId, productName) {
  const thunk = (dispatch, getState) => {
    
    const orderGuide = getState().orderGuide;
    dispatch(setProductsResetKeyStatus(SAME_PROCESS_FLAG));
    return api.request(
      `endecaSearch/product/list?opcoId=${ opcoId }&syscoCustomerId=${ syscoCustomerId }&index=0&productName=${ productName }&numberPerPage=1000`,
      'get',
      null
    )
    .then((data) => {
      let newProducts = data;
      const resetKey = getState().products.resetKey;
      if(resetKey == SAME_PROCESS_FLAG) {
        let tempProducts = newProducts.products;
        tempProducts.map((product, index) => {
          orderGuide.products.map((item) => {
            if(product.supc === item.supc) {
              product.lastOrderedDate = item.lastOrderedDate;
            }
          });
        });
        newProducts.products = tempProducts;
        dispatch(productsAsyncUpdateSuccess(newProducts));
      }
      dispatch(setLoadingProductsStatus(false));
      return newProducts;
    })
    .catch(() => {
      dispatch(setLoadingProductsStatus(false));
      dispatch(productsAsyncUpdateSuccess({
        firstRecNum: 0,
        lastRecNum: 0,
        totalNumRecs: 0,
        products: [],
      }));
    });
  };
  thunk.meta = {
    debounce: {
      time: 500,
      key: DEBOUNCE_PRODUCTS,
    },
  };
  return thunk;
}

export function fetchProductPrice(productList) {
  return (dispatch, getState) => {
    
    const args = productList.map(product => {
      return {
        supc: product.supc,
        isSoldAs_split: product.isSoldAs_split,
      };
    });
    return api.request('price', 'post', args).then((data) => {
      const productPrices = data.map(productPrice => {
        return {
          supc: productPrice.supc,
          unitCost: productPrice.price,
          priceLoaded: true,
          priceLoadSuccess: true,
        };
      });
      dispatch(updateProductPrice(productPrices));
    }).catch(() => {
      const productPrices = productList.map(product => {
        return {
          supc: product.supc,
          priceLoaded: true,
          priceLoadSuccess: false,
        };
      });
      dispatch(updateProductPrice(productPrices));
    });
  };
}
